import { StandardVertical } from 'entities/vertical'

const DESCRIPTION_MAX_LENGTH = 320

export const textToSeoDescription = (s: string) =>
    s.slice(0, DESCRIPTION_MAX_LENGTH - 3) + '...'

export const canonicalUrl = (vertical: StandardVertical, pathname: string) => {
    return `https://${vertical}.works-hub.com${pathname}`
}
